export const AUTH_LOGIN_PATH = '/authorization/login';
export const AUTH_ME_PATH = '/authorization/me';
export const AUTH_REFRESH_PATH = '/authorization/refresh';
